// extracted by mini-css-extract-plugin
export var container = "_ff-1";
export var cornerButtonContainer = "_ff-6";
export var disabled = "_ff-2";
export var dragActive = "_ff-3";
export var fileContainer = "_ff-5";
export var hiddenInput = "_ff-4";
export var widthContainer = "_ff-0";